const { 
    update_button_visibility,
    clear_error,
    render_verify_error,
    register_verify_error_rederer,
    default_error_rederer    
} = require('./page_transition.js');

const {
    input_empty,
    input_valid_email
} = require('./form_check_helper');

const nunjucks = require('nunjucks');

// ベリファイエラーレンダラーの追加
register_verify_error_rederer("verify-4019c8be-1a44-464a-a8de-d6588f65ee92",default_error_rederer);
register_verify_error_rederer("verify-b5bd44cb-d524-4399-bd71-2d48603014c4",default_error_rederer);
register_verify_error_rederer("verify-b055e80e-0b82-4eb8-99a0-ca52929d66e7",default_error_rederer);
register_verify_error_rederer("verify-7631637a-56ef-4d09-83e0-e03966bfd68f",default_error_rederer);


const page3_verify=(application_context)=>{
    

    application_context.ary_verify_error ??= [];

    // check1
    let DOM_input_name;
    DOM_input_name = document.querySelector(`[data-page="3"] [name="name"]`);
    if(DOM_input_name === null) {
        return false;
    }
    if(input_empty(DOM_input_name)){
        application_context.ary_verify_error.push({
            code:"verify-4019c8be-1a44-464a-a8de-d6588f65ee92",
            data:{
                field_name:"name",
                description:`お名前を入力してください`
            }
        });
    }

    // check2
    let DOM_input_email;
    DOM_input_email = document.querySelector(`[data-page="3"] [name="email"]`);
    if(DOM_input_email === null) {
        return false;
    }
    if(input_empty(DOM_input_email)){
        application_context.ary_verify_error.push({
            code:"verify-b5bd44cb-d524-4399-bd71-2d48603014c4",
            data:{
                field_name:"email",
                description:`メールアドレスを入力ください`
            }
        });
    } else {
        if(input_valid_email(DOM_input_email,{validator:application_context.library.validator}) === false){
            application_context.ary_verify_error.push({
                code:"verify-b5bd44cb-d524-4399-bd71-2d48603014c4",
                data:{
                    field_name:"email",
                    description:`有効なメールアドレスを入力ください`
                }
            });
        }
    }

    // check3
    //
    let DOM_input_birthdate;
    DOM_input_birthdate = document.querySelector(`[data-page="3"] [name="birthdate"]`);
    if(DOM_input_birthdate === null) {
        return false;
    }
    if(input_empty(DOM_input_birthdate)){
        application_context.ary_verify_error.push({
            code:"verify-b055e80e-0b82-4eb8-99a0-ca52929d66e7",
            data:{
                field_name:"birthdate",
                description:`生年月日を入力ください`
            }
        });
    }

    // check4
    let DOM_input_tel;
    DOM_input_tel = document.querySelector(`[data-page="3"] [name="tel"]`);
    if(DOM_input_tel === null) {
        return false;
    }
    if(input_empty(DOM_input_tel)){
        application_context.ary_verify_error.push({
            code:"verify-7631637a-56ef-4d09-83e0-e03966bfd68f",
            data:{
                field_name:"tel",
                description:`連絡先電話番号を入力ください`
            }
        });
    }


    return (application_context.ary_verify_error.length === 0);
}

module.exports.page3_prev = (application_context)=>{
    let page;

    window.splide_instance.go("<");

    page = window.splide_instance.index;
    application_context.page = page;

    update_button_visibility(application_context);    
}


module.exports.page3_next = (application_context)=>{

    // 次に進むタイミングでベリファイエラーをリセットする。
    application_context.ary_verify_error.length=0;
    clear_error({page:3});

    if(page3_verify(application_context)){
        let page;

        window.splide_instance.go(">");

        page = window.splide_instance.index;
        application_context.page = page;
        
        update_button_visibility(application_context);
    } else {
        for(let blob_verify_error of application_context.ary_verify_error){
            render_verify_error(blob_verify_error);
        }
    }

}
